<template>
  <app-layout title="Главная страница">
    <v-card height="100%" width="100%">
      <v-card-title>ЗАЯВКИ</v-card-title>
      <v-card-text>
        <v-tabs>
          <v-tab
            @click="switchTab(tab.id)"
            v-for="tab in tabs"
            :key="tab.id"
          >
            {{ tab.title }}
          </v-tab>
        </v-tabs>
        <orders-table
          :isLoading="isLoading"
          hideActions
          :orders="list"
          :onMakeRequest="startBuyout"
        />
      </v-card-text>
    </v-card>
  </app-layout>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import AppLayout from '../components/AppLayout.vue';
  import OrdersTable from '../components/OrdersTable.vue';
  import Visibility from 'visibilityjs';


  export default {
    data: () => ({
      selectedTabId: 1,
      tabs: [{
        id: 1,
        title: 'Новые',
      }],
    }),
    components: {
      AppLayout,
      OrdersTable,
    },
    created() {
      this.fetchTable()
      this.refreshInterval = Visibility.every(2500, this.fetchTable);
      // setInterval(() => {
      //     this.loadOrders({
      //       filters: {
      //         new: 1
      //       },
      //     });
      //   }, 2500);
    },
    methods: {
      ...mapActions('orders', [
        'loadOrders',
      ]),
      startBuyout(id) {
        this.$router.push({
          name: 'createBuyout',
          params: { id }
        });
      },
      switchTab(id) {
        this.selectedTabId = id;
        this.loadOrders({
          filters: {
            status: id,
            new: 1
          },
        });
      },
      fetchTable() {
        this.loadOrders({
          page: 1,
          filters: { new: 1 }
        });
      },
    },
    computed: {
      ...mapGetters('orders', ['list', 'isLoading']),
    },
    async beforeDestroy() {
      Visibility.stop(this.refreshInterval);
    }
  };
</script>
